<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-notification-docs-preview></ui-notification-docs-preview></p>
<h1 id="description">Description</h1>
<h1 id="usage">Usage</h1>
<pre><code class="language-ts"><span class="hljs-keyword">constructor</span>(<span class="hljs-params"><span class="hljs-keyword">private</span> uiNotificationService: UINotificationService</span>) {{ '{' }}{{ '}' }}

showNotification(): <span class="hljs-built_in">void</span> {{ '{' }}
    <span class="hljs-keyword">this</span>.uiNotificationService.open(<span class="hljs-string">'Hello world!'</span>, {{ '{' }} <span class="hljs-keyword">type</span>: <span class="hljs-string">'error'</span> {{ '}' }});
{{ '}' }}
</code></pre>
<h2 id="config">Config</h2>
<pre><code class="language-ts"><span class="hljs-keyword">type</span>?: <span class="hljs-string">'info'</span> | <span class="hljs-string">'warning'</span> | <span class="hljs-string">'error'</span> | <span class="hljs-string">'success'</span>;
icon?: <span class="hljs-built_in">string</span>;
autoCloseDelay?: <span class="hljs-built_in">number</span>;
placement?: <span class="hljs-string">'top'</span> | <span class="hljs-string">'bottom'</span> | <span class="hljs-string">'top right'</span> | <span class="hljs-string">'top left'</span> | <span class="hljs-string">'bottom left'</span> | <span class="hljs-string">'bottom right'</span>;
hideCloseIcon?: <span class="hljs-built_in">boolean</span>;</code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
